import { useAuth } from '../auth/hooks';
import './Layout.css';

interface DevOrgSelectorProps {
  variant?: 'header' | 'panel';
}

export default function DevOrgSelector({ variant = 'header' }: DevOrgSelectorProps) {
  const {
    availableOrganizations,
    availableLocalUsers,
    canUseLocalImpersonation,
    isLocalImpersonation,
    selectedLocalRole,
    selectedLocalUserId,
    selectedOrganizationId,
    setSelectedLocalRole,
    setSelectedLocalUserId,
    setSelectedOrganizationId,
  } = useAuth();

  if (!canUseLocalImpersonation) {
    return null;
  }

  const containerClassName = variant === 'panel' ? 'dev-org-selector dev-org-selector-panel' : 'dev-org-selector';
  const hasSelectedOrganization = !!selectedOrganizationId;

  return (
    <div className={containerClassName}>
      <div className="dev-org-selector-group">
        <label className="dev-org-selector-label" htmlFor={`dev-org-selector-${variant}`}>
          Local org
        </label>
        <select
          id={`dev-org-selector-${variant}`}
          className="dev-org-selector-input"
          value={selectedOrganizationId ?? ''}
          onChange={(event) => setSelectedOrganizationId(event.target.value || null)}
        >
          <option value="">Select an organization</option>
          {availableOrganizations.map((organization) => (
            <option key={organization.id} value={organization.id}>
              {organization.name}
            </option>
          ))}
        </select>
      </div>

      <div className="dev-org-selector-group">
        <label className="dev-org-selector-label" htmlFor={`dev-user-selector-${variant}`}>
          Local user
        </label>
        <select
          id={`dev-user-selector-${variant}`}
          className="dev-org-selector-input"
          value={selectedLocalUserId ?? ''}
          onChange={(event) => setSelectedLocalUserId(event.target.value || null)}
          disabled={!hasSelectedOrganization}
        >
          <option value="">Synthetic developer user</option>
          {availableLocalUsers.map((localUser) => (
            <option key={localUser.id} value={localUser.id}>
              {localUser.displayName} ({localUser.email})
            </option>
          ))}
        </select>
      </div>

      <div className="dev-org-selector-group">
        <label className="dev-org-selector-label" htmlFor={`dev-role-selector-${variant}`}>
          Effective role
        </label>
        <select
          id={`dev-role-selector-${variant}`}
          className="dev-org-selector-input"
          value={selectedLocalRole}
          onChange={(event) => setSelectedLocalRole(event.target.value as 'admin' | 'member')}
          disabled={!hasSelectedOrganization}
        >
          <option value="member">Member</option>
          <option value="admin">Admin</option>
        </select>
      </div>

      {isLocalImpersonation && (
        <button
          type="button"
          className="dev-org-selector-clear"
          onClick={() => setSelectedOrganizationId(null)}
        >
          Use real auth
        </button>
      )}
    </div>
  );
}